(function () {
  'use strict';

  var EAGER_SELECTORS = [
    '.rabitat-hero-slider__slide.is-active img',
    '.rabitat-header__logo img',
    '.rabitat-mobile-menu__logo img',
    'img[loading="eager"]',
    'img[fetchpriority="high"]',
  ];

  function isHeroProductImage(img) {
    var track = img.closest('[data-product-hero-track]');
    if (!track) return false;

    var firstImage = track.querySelector(
      '.rabitat-product-page__hero-image:not(.rabitat-product-page__hero-image--placeholder), [data-product-hero-slide]:first-child img'
    );

    return firstImage === img;
  }

  function shouldLoadEager(img) {
    if (!img || img.tagName !== 'IMG') return false;
    if (img.loading === 'eager' || img.getAttribute('fetchpriority') === 'high') return true;
    if (isHeroProductImage(img)) return true;

    for (var i = 0; i < EAGER_SELECTORS.length; i++) {
      try {
        if (img.matches(EAGER_SELECTORS[i])) return true;
      } catch (error) {
        /* ignore invalid selectors in older browsers */
      }
    }

    return false;
  }

  function applyLazyLoading(root) {
    var images = [];

    if (root && root.nodeType === 1 && root.tagName === 'IMG') {
      images = [root];
    } else if (root && typeof root.querySelectorAll === 'function') {
      images = Array.prototype.slice.call(root.querySelectorAll('img:not([loading])'));
    } else {
      images = Array.prototype.slice.call(document.querySelectorAll('img:not([loading])'));
    }

    images.forEach(function (img) {
      if (img.hasAttribute('loading')) return;

      img.loading = shouldLoadEager(img) ? 'eager' : 'lazy';

      if (!img.hasAttribute('decoding')) {
        img.decoding = 'async';
      }
    });
  }

  function init() {
    applyLazyLoading(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    applyLazyLoading(event.target);
  });
})();
